

























import Component from "vue-class-component";
import Vue from "vue";
import { Prop } from "vue-property-decorator";
import ModalConfirm from "@/components/ModalConfirm.vue";
import BlockTagItem from "./BlockTagItem.vue";
import BlockTagsAdd from "./BlockTagsAdd.vue";
import BlockTagsEdit from "./BlockTagsEdit.vue";
import ModalContainer from "@/components/ModalContainer.vue";
import { TagInfo } from "@teacherskaya/api-provider/dist/api/TagsProvider";
import { CheckAuthorities } from "@/lib/helpers/componentViewController/decorators";

@Component({
  components: { ModalConfirm, BlockTagItem, ModalContainer, BlockTagsAdd, BlockTagsEdit },
})
export default class BlockTagsController extends Vue {
  @Prop({ type: Array, required: true })
  public readonly tags!: TagInfo[];

  public showDeleteDialog: boolean = false;

  public tagToDelete: TagInfo | null = null;

  public tagToEdit: TagInfo | null = null;

  public showEditTag: boolean = false;

  public showAddTag: boolean = false;

  @CheckAuthorities("BlockUserTags", "create_any")
  public allowCreate!: boolean;

  public save(newTag: TagInfo, BlockBaseFormInstance: any) {
    this.showEditTag = false;
    return this.$emit("save", newTag, BlockBaseFormInstance);
  }

  public cancelEdit() {
    this.showEditTag = false;
  }

  public create(title: string) {
    this.showAddTag = false;
    return this.$emit("create", title);
  }

  public deleteTag() {
    this.tagToDelete = this.tagToEdit;
    this.showDeleteDialog = true;
  }

  public confirmDelete() {
    if (this.tagToDelete) {
      this.$emit("deleteTag", this.tagToDelete.id);
      this.cancelDelete();
    }
    this.showEditTag = false;
  }

  public cancelDelete() {
    this.showDeleteDialog = false;
    this.tagToDelete = null;
  }

  public openEdit(tag: TagInfo) {
    this.tagToEdit = tag;
    this.showEditTag = true;
  }
}
